import { AttachmentService } from "../../../services/AttachmentService";
import { EmailBuilderWrapper } from "../../../services/EmailBuilderWrapper";
import { IEmailAttachmentCreation } from "../../../interfaces/IEmailAttachmentCreation";
import { IAttachmentInfo } from "../../../interfaces/IAttachmentInfo";

export class CreateEmailer implements IEmailAttachmentCreation {
  constructor(private isOrganization: boolean) {}
  async withAttachment(items: IAttachmentInfo[]) {
    const attachments = await AttachmentService.getAttachmentLinks(items);
    await EmailBuilderWrapper.createNewEmail(attachments);
  }

  async withShareableLink(items: IAttachmentInfo[]) {
    const shareableLinks = await AttachmentService.getShareableLinks(items, this.isOrganization);
    await EmailBuilderWrapper.createNewEmailWithLink(shareableLinks);
  }
}
